export default __webpack_public_path__ + "media/images/plot-1-hr-2cb3c15115efa41f4af4d16d8588bd52.png";